<template>
  <div class="files__wrapper">
    <v-chip
      v-for="file in adminAppointmentOutputs"
      :key="file.id"
      :href="file.url"
      color="grey lighten-3"
      class="files__item"
      target="_blank"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div class="files__select">
            <input
              @change="pushFilesToDelete(file)"
              type="checkbox"
              :id="file.id"
            />
            <label :for="file.id" v-on="on" v-bind="attrs">
              <v-icon>mdi-check-bold</v-icon>
            </label>
          </div>
        </template>
        <span>{{ $t('upload.select') }}</span>
      </v-tooltip>

      <strong>{{ file.name }}</strong>

      <div class="files__actions">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              @click.prevent="deleteFile(file)"
              :disabled="isAppointmentFilesDeleting"
              color="red"
              class="ml-3"
              icon
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('upload.exclude') }}</span>
        </v-tooltip>
      </div>
    </v-chip>

    <HUploading v-if="isAppointmentOutputsUploading" class="mb-4" />

    <div class="d-block mh-5 mb-n1">
      <v-progress-linear
        v-if="isAppointmentFilesLoading"
        color="primary"
        indeterminate
        absolute
      />
    </div>

    <HUpload
      @change="handleGetOutputs"
      componentId="uploadOutputs"
      multiple
    />

    <ModalAppointmentDeleteOneFile
      :handleDelete="deleteAppointmentOutputsAsAdmin"
      @resetSelectedFiles="setAdminAppointmentOutputsToDelete([])"
      modalName="DELETE_ONE_APPOINTMENT_OUTPUT"
    />

    <ModalAdminAppointmentDeleteAllOutputs :handleDelete="deleteAppointmentOutputsAsAdmin" />

    <ModalAppointmentDeleteSelectedFiles
      :handleDelete="deleteAppointmentOutputsAsAdmin"
      :files="adminAppointmentOutputsToDelete"
      modalName="DELETE_SELECTED_APPOINTMENT_OUTPUTS"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import HUpload from '../lib/HUpload'
import HUploading from '@/components/app/HUploading'

import ModalAppointmentDeleteOneFile from './modals/ModalAppointmentDeleteOneFile'
import ModalAdminAppointmentDeleteAllOutputs from './modals/admin/output/ModalAdminAppointmentDeleteAllOutputs'
import ModalAppointmentDeleteSelectedFiles from './modals/admin/ModalAppointmentDeleteSelectedFiles'

export default {
  name: 'AdminAppointmentOutputsUpload',
  components: {
    HUpload,
    HUploading,
    ModalAppointmentDeleteOneFile,
    ModalAdminAppointmentDeleteAllOutputs,
    ModalAppointmentDeleteSelectedFiles,
  },

  data() {
    return {
      file: null,
    }
  },

  computed: {
    ...mapGetters([
      'adminAppointmentOutputs',
      'isAppointmentFilesLoading',
      'isAppointmentFilesDeleting',
      'isAppointmentOutputsUploading',
      'adminAppointmentOutputsToDelete',
    ]),
  },

  methods: {
    ...mapActions([
      'openModal',
      'attachAppointmentOutputsAsAdmin',
      'deleteAppointmentOutputsAsAdmin',
    ]),

    ...mapMutations(['closeAllModals', 'setAdminAppointmentOutputsToDelete']),

    handleGetOutputs(files) {
      this.attachAppointmentOutputsAsAdmin(files)
    },

    expandFile(url) {
      this.file = url
      this.openModal('APPOINTMENT_FILE_VISUALIZATION')
    },

    deleteFile(file) {
      this.setAdminAppointmentOutputsToDelete([])

      Promise.resolve(this.setAdminAppointmentOutputsToDelete([file])).then(() => {
        this.openModal('DELETE_ONE_APPOINTMENT_OUTPUT')
      })
    },

    pushFilesToDelete(id) {
      const files = this.adminAppointmentOutputsToDelete
      const index = files.indexOf(id)

      if (index >= 0) {
        files.splice(index, 1)
        this.setAdminAppointmentOutputsToDelete(files)
      } else {
        files.push(id)
        this.setAdminAppointmentOutputsToDelete(files)
      }
    },
  },
}
</script>
